// Legacy `clrCode` values always disabled in the correction letter popup.
export const LOCKED_CORRECTION_REASON_CODES: ReadonlySet<string> = new Set([
  "VSC_PROV",
  "VSC_T_MILE",
  "VSC_T_MNTH",
  "GAP_PROV",
]);
